const React = require('react');
const ReactRouter = require('react-router-dom');
const Route = ReactRouter.Route;
const Switch = ReactRouter.Switch;

/**
 * Components
 *
 * @type {exports}
 */
const FuzzyReaction = require('./bootstrap').FuzzyReaction;
const Fz = FuzzyReaction.require('components', 'Login', 'Logout');

/**
 * CMS Pages
 */
const pages = require('./pages');

/**
 * Routing
 *
 * This configuration doesn't necessarily map to routes, but to how the layout is presented by the router
 *
 * @type {JSX.Element}
 */
const Routes = (
    <Switch>
        <Route path="/login" component={Fz.Login}/>

        <Route path="/logout" component={Fz.Logout}/>

        <Route path="/password-reset" component={Fz.Login}/>

        <Route exact strict path="/instructors/" component={pages.InstructorDetail}/>
        <Route path="/instructors/:id" component={pages.InstructorDetail}/>
        <Route path="/instructors" component={pages.Instructors}/>

        <Route path="/music-library/add-track-manually" component={pages.AddManualTrack}/>
        <Route path="/music-library" component={pages.MusicLibrary}/>

        <Route exact strict path="/cast-library/cast-tracks/" component={pages.TrackManagement}/>
        <Route exact strict path="/cast-library/" component={pages.CastDetail}/>
        <Route path="/cast-library/cast-tracks/:id" component={pages.TrackManagement}/>
        <Route path="/cast-library/:id" component={pages.CastDetail}/>
        <Route path="/cast-library" component={pages.CastLibrary}/>

        <Route path="/genres" component={pages.Genres}/>

        <Route path="/reports/song-plays" component={pages.SongPlaysReport}/>

        <Route path="/menu-urls" component={pages.MenuUrls}/>

        <Route path="/movements" component={pages.Movements}/>

        <Route path="/subscribers" component={pages.Subscribers}/>

        <Route exact strict path="/codes/manage-code/" component={pages.CreateCode}/>
        <Route path="/codes/manage-code/:id" component={pages.CreateCode}/>
        <Route path="/codes/:id" component={pages.CodeDetail}/>
        <Route path="/codes" component={pages.Codes}/>

        <Route path="/subscriptions" component={pages.Subscriptions}/>

        <Route path="/legal-disclaimer" component={pages.LegalDisclaimer}/>

        <Route exact strict path="/email-messages/" component={pages.EmailManagement}/>
        <Route path="/email-messages/:id" component={pages.EmailManagement}/>
        <Route path="/email-messages" component={pages.EmailMessages}/>

        <Route exact strict path="/push-messages/" component={pages.PushManagement}/>
        <Route path="/push-messages/:id" component={pages.PushManagement}/>
        <Route path="/push-messages" component={pages.PushMessages}/>

        <Route path="/workouts" component={pages.Workouts}/>

        <Route path="/" component={pages.CastLibrary}/>
    </Switch>
);

module.exports = Routes;
